import { formatMoney } from "~/utils/formatMoney"

const ProductsCard = ({ addonData, camp }) => {
  const { name, current_price, reservation_quantity, quantity, total, tax_fee } = addonData

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200">
      <div className="mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">{name}</h3>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <div>
          <p className="text-xs text-gray-500">Current Price</p>
          <p className="text-base font-medium">{formatMoney(current_price, camp?.currency)}</p>
        </div>

        <div>
          <p className="text-xs text-gray-500">Total Sold</p>
          <p className="text-base font-medium">{quantity}</p>
        </div>

        <div>
          <p className="text-xs text-gray-500">Reservations</p>
          <p className="text-base font-medium">{reservation_quantity}</p>
        </div>

        <div>
          <p className="text-xs text-gray-500">Tax</p>
          <p className="text-base font-medium">{formatMoney(tax_fee, camp?.currency)}</p>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">Net Total</span>
          <span className="text-lg font-semibold text-gray-900">{formatMoney(total, camp?.currency)}</span>
        </div>
      </div>
    </div>
  )
}

export default ProductsCard
